import React, { useState } from "react";
import { CloudUpload, FileDownload, Description } from "@mui/icons-material";
import { toast } from "react-toastify";
import { ThreeDots } from "react-loader-spinner";
import { API_BASE_URL } from "../config/api";

export default function Upload({ onTabChange }) {
  const [loading, setLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);

  const handleFileUpload = async (event) => {
    try {
      const file = event.target.files[0];
      if (!file) return;
      
      setUploadedFile(file);
      setLoading(true);
      
      const url = API_BASE_URL;
      const token = localStorage.getItem("authToken");
      const requestData = new FormData();
      requestData.append("contact_file", file);
      
      const response = await fetch(`${url}/upload_contact`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: requestData,
      });
      
      if (response.ok) {
        const { message } = await response.json();
        toast.success(message, { autoClose: 3000 });
        setLoading(false);
        onTabChange(4);
      }
    } catch (error) {
      console.error("An error occurred:", error);
      toast.error("An error occurred: " + error, { autoClose: 3000 });
      setLoading(false);
      setUploadedFile(null);
    }
  };

  const handleFileDownload = async () => {
    try {
      setLoading(true);
      const url = API_BASE_URL;
      const token = localStorage.getItem("authToken");
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      
      const res = await fetch(url + `/contact_template`, requestOptions);
      const data = await res.json();
      const downloadUrl = data?.data?.path || "";
      const response = await fetch(downloadUrl);
      const blob = await response.blob();
      
      const downloadLink = document.createElement("a");
      downloadLink.download = "contacts_template.csv";
      downloadLink.href = window.URL.createObjectURL(blob);
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      setLoading(false);
    } catch (error) {
      console.error("Error downloading file:", error);
      setLoading(false);
    }
  };

  return (
    <div className="profile_page">
      <div className="container">
        {/* Upload Section */}
        <div className="profile_section">
          <div className="section_header">
            <h3>Import Contacts</h3>
            <p>Upload a CSV file to bulk import your contacts</p>
          </div>
          <div className="section_content">
            {loading ? (
              <div className="upload_loading">
                <ThreeDots
                  height="60"
                  width="80"
                  radius="9"
                  color="#B1903F"
                  ariaLabel="three-dots-loading"
                  visible={true}
                />
                <p>Processing your file...</p>
              </div>
            ) : (
              <div className="upload_area">
                <div className="upload_dropzone">
                  <input
                    type="file"
                    accept=".csv"
                    id="file-upload"
                    onChange={handleFileUpload}
                  />
                  <div className="dropzone_content">
                    <CloudUpload className="upload_icon" />
                    <h4>Drop your CSV file here</h4>
                    <p>or click to browse from your computer</p>
                    <span className="file_hint">Accepts .csv files only</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Template Download Section */}
        <div className="profile_section">
          <div className="section_header">
            <h3>Need a Template?</h3>
            <p>Download our CSV template to ensure your data is formatted correctly</p>
          </div>
          <div className="section_content">
            <div className="template_download">
              <div className="template_info">
                <Description className="template_icon" />
                <div className="template_details">
                  <h4>Contacts Template</h4>
                  <p>Pre-formatted CSV with all required columns</p>
                </div>
              </div>
              <button 
                onClick={handleFileDownload} 
                className="download_template_btn"
                disabled={loading}
              >
                <FileDownload />
                Download Template
              </button>
            </div>
          </div>
        </div>

        {/* Instructions Section */}
        <div className="profile_section">
          <div className="section_header">
            <h3>How It Works</h3>
            <p>Follow these steps to import your contacts</p>
          </div>
          <div className="section_content">
            <div className="instructions_grid">
              <div className="instruction_step">
                <span className="step_number">1</span>
                <h4>Download Template</h4>
                <p>Get our CSV template with the correct column headers</p>
              </div>
              <div className="instruction_step">
                <span className="step_number">2</span>
                <h4>Add Your Data</h4>
                <p>Fill in your contact information in the spreadsheet</p>
              </div>
              <div className="instruction_step">
                <span className="step_number">3</span>
                <h4>Upload File</h4>
                <p>Upload your completed CSV file above</p>
              </div>
              <div className="instruction_step">
                <span className="step_number">4</span>
                <h4>Review Contacts</h4>
                <p>Check your imported contacts in My Contacts tab</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
